import React from "react";
import "../../styles/components/RelatioHero.css";

import drslPhone from "../../img/cases/drsl-phone-2.webp";
import cloudsImage from "../../img/cases/case-clouds-2.webp";
import drslLogo from "../../img/cases/drsl-logo.png";

export default function DrslHero() {
  return (
    <section className="relatio-hero relatio-hero--drsl relatio-hero-anim">
      <div className="relatio-hero__content relatio-hero-anim__content">
        <h1 className="relatio-hero__title">
          AI-Powered <strong>Virtual Try-On</strong> with Realistic
          <br />
          <strong>Garment Rendering</strong>
        </h1>

        <p className="relatio-hero__text">
          A high-precision AI system that enables 10M+ monthly users to try on
          clothing digitally — with stable quality, identity preservation, and
          no rendering artifacts.
        </p>

        <div className="relatio-hero__chips">
          <span>LangChain/LangGraph</span>
          <span>Nano Banana</span>
          <span>Qwen</span>
          <span>Seedream</span>
          <span>Pinecone</span>
          <span>Elasticsearch</span>
        </div>
      </div>

      <div className="relatio-hero__glass relatio-hero__glass--client relatio-hero-anim__glass-1">
        <span>Client</span>
        <img
          className="relatio-hero__logo relatio-hero__logo--drsl"
          src={drslLogo}
          alt="DRSL"
        />
      </div>

      <div className="relatio-hero__glass relatio-hero__glass--industry relatio-hero-anim__glass-2">
        <span>Industry</span>
        <strong>AI STYLIST</strong>
      </div>

      <img
        className="relatio-hero__clouds relatio-hero-anim__clouds"
        src={cloudsImage}
        alt=""
        aria-hidden="true"
      />

      <img
        className="relatio-hero__phone relatio-hero__phone--drsl relatio-hero-anim__phone"
        src={drslPhone}
        alt="DRSL app"
      />
    </section>
  );
}
